<script setup lang="ts">
import { RouterView } from 'vue-router'
import OfflineBadge from '@/components/OfflineBadge.vue'
</script>

<template>
  <div class="min-h-screen flex flex-col">
    <OfflineBadge />
    <RouterView />
  </div>
</template>
